import React from 'react';
import cn from 'classnames';
import { useWidth } from '../hooks/useWidth';
import { addMissingProtocol } from '../../../components/utils/validateHref';
import s from './Viewer.scss';
const Viewer = (props)=>{
    var _props_node_externalRenderers, _props_node_extensionConfig;
    const attrs = props.node.attrs;
    const { alignment, deviations, layout, linkOverrides, layoutRowAlignment, layoutSpacing, gridItemHeight, gridItemWidth, itemCropping, torpedoRowHeight } = attrs;
    const Renderer = (_props_node_externalRenderers = props.node.externalRenderers) === null || _props_node_externalRenderers === void 0 ? void 0 : _props_node_externalRenderers.gallery;
    const config = (_props_node_extensionConfig = props.node.extensionConfig) === null || _props_node_extensionConfig === void 0 ? void 0 : _props_node_extensionConfig.gallery;
    const align = alignment === 'left' ? s['left'] : alignment === 'right' ? s['right'] : s['center'];
    const { width } = useWidth(attrs.width, config.defaultWidth, !!config.smallMedia, props.node.containerWidth);
    for(const key in linkOverrides){
        linkOverrides[key] = addMissingProtocol(linkOverrides[key]);
    }
    return /*#__PURE__*/ React.createElement("div", {
        key: `gallery-`,
        className: cn(s['gallery-container'], s[`preset-${props.node.presetId}`], align),
        "data-da-type": "da-gallery",
        "data-width": attrs.width,
        "data-alignment": alignment !== null && alignment !== void 0 ? alignment : config.defaultAlignment,
        "data-layout": layout !== null && layout !== void 0 ? layout : config.defaultLayout,
        "data-layoutspacing": layoutSpacing !== null && layoutSpacing !== void 0 ? layoutSpacing : config.defaultLayoutSpacing,
        "data-layoutrowalignment": layoutRowAlignment,
        "data-itemcropping": itemCropping,
        "data-griditemwidth": gridItemWidth !== null && gridItemWidth !== void 0 ? gridItemWidth : config.defaultGridItemWidth,
        "data-griditemheight": gridItemHeight !== null && gridItemHeight !== void 0 ? gridItemHeight : config.defaultGridItemHeight,
        "data-torpedorowheight": torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : config.defaultTorpedoRowHeight
    }, /*#__PURE__*/ React.createElement(Renderer, {
        deviations: deviations,
        width: width,
        extOptions: config,
        linkOverrides: linkOverrides,
        layoutSpacing: layoutSpacing,
        layoutRowAlignment: layoutRowAlignment,
        itemCropping: itemCropping,
        gridItemWidth: gridItemWidth,
        gridItemHeight: gridItemHeight,
        torpedoRowHeight: torpedoRowHeight,
        layout: layout
    }));
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map